import React from "react";
import PageHero, { PageCTA } from "../components/PageHero";
import { AlertTriangle, Wrench, Clock, Phone, Check } from "lucide-react";
import { heroImages, emergencySteps, companyInfo } from "../data/mock";

const DepannagePorte = () => {
  return (
    <div>
      <PageHero
        title="Dépannage de porte Fichet"
        subtitle="Porte endommagée, tentative d'effraction ou bloc-porte forcé ? Nous rétablissons votre sécurité immédiatement."
        breadcrumb="Dépannage de porte"
        badge="Urgence 24/7"
        image={heroImages.depannagePorte}
      />

      {/* EMERGENCY */}
      <section className="bg-[#C9A227] py-8">
        <div className="max-w-[1400px] mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <AlertTriangle className="w-10 h-10 text-black" />
            <div>
              <div className="text-xl font-black text-black tracking-tight">Intervention d'urgence</div>
              <div className="text-sm text-black/80">Nous sécurisons votre porte immédiatement, même la nuit et le week-end</div>
            </div>
          </div>
          <a href={`tel:${companyInfo.emergencyPhone.replace(/\s/g, "")}`} className="inline-flex items-center gap-3 bg-[#123B2E] text-white font-bold px-6 py-4 hover:bg-[#1B4D3C] transition-colors">
            <Phone className="w-5 h-5" />
            {companyInfo.emergencyPhone}
          </a>
        </div>
      </section>

      {/* SERVICES */}
      <section className="py-20 bg-white">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="text-center mb-14 max-w-2xl mx-auto">
            <div className="text-sm font-bold text-[#8C6F14] tracking-widest uppercase mb-3">Nos interventions</div>
            <h2 className="text-3xl md:text-5xl font-black tracking-tight text-black">Ce que nous réparons</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { title: "Porte forcée ou fracturée", desc: "Sécurisation immédiate et remplacement du bloc-porte après effraction." },
              { title: "Cylindre percé ou cassé", desc: "Remplacement du cylindre par un modèle Fichet haute sécurité." },
              { title: "Serrure enfoncée", desc: "Réparation ou remplacement complet de la serrure endommagée." },
              { title: "Gonds arrachés", desc: "Remise en état de la structure porteuse et pose de renforts anti-arrachement." },
              { title: "Encadrement déformé", desc: "Redressage ou remplacement du dormant pour restaurer l'étanchéité." },
              { title: "Blindage endommagé", desc: "Renforcement du bloc-porte avec plaque de blindage certifiée A2P." },
            ].map((s, i) => (
              <div key={i} className="p-7 bg-gray-50 hover:bg-white hover:shadow-lg transition-all border-l-4 border-[#C9A227]">
                <Wrench className="w-8 h-8 text-black mb-3" />
                <h3 className="text-lg font-bold text-black mb-2 tracking-tight">{s.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROCESS */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="text-center mb-14 max-w-2xl mx-auto">
            <div className="text-sm font-bold text-[#8C6F14] tracking-widest uppercase mb-3">Notre méthode</div>
            <h2 className="text-3xl md:text-5xl font-black tracking-tight text-black">Une intervention en 4 étapes</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {emergencySteps.map((step, i) => (
              <div key={i}>
                <div className="text-6xl font-black text-[#C9A227] mb-3 tracking-tight">{step.number}</div>
                <h3 className="text-lg font-bold text-black mb-2 tracking-tight">{step.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* GUARANTEES */}
      <section className="py-20 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          <img src={heroImages.installer} alt="Serrurier au travail" className="w-full h-[460px] object-cover" />
          <div>
            <div className="text-sm font-bold text-[#8C6F14] tracking-widest uppercase mb-3">Nos engagements</div>
            <h2 className="text-3xl md:text-4xl font-black tracking-tight text-black leading-tight mb-6">
              Un dépannage transparent et professionnel
            </h2>
            <ul className="space-y-3">
              {[
                "Devis clair et forfait annoncé par téléphone",
                "Aucun frais de déplacement supplémentaire",
                "Serruriers certifiés Fichet et assurés",
                "Facture détaillée pour votre assurance",
                "Pièces d'origine Fichet garanties",
                "Garantie 2 ans sur toute intervention",
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-[#C9A227] flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Check className="w-4 h-4 text-black" />
                  </div>
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <PageCTA title="Porte endommagée ? Ne restez pas sans sécurité." subtitle="Intervention immédiate 24h/24 partout en France" />
    </div>
  );
};

export default DepannagePorte;
